import { memo } from 'react';

import { IconCloseSmall } from '@components/icons/close-small';
import { Tag } from '@components/tag';
import { useScopedTranslate } from '@locale/translate';

import { TravellerJourneyAction } from 'api/types';
import { MoreItems, TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { getConditionDescription, getConditionTooltip } from './journey-node';

import { actionCardStyles, tagStyles } from '../condition-v2/traveller-node';

type ActionType = 'condition';

export const getDescription = (action: TravellerJourneyAction<ActionType>): string => {
  return getConditionDescription({ values: action.values, styled: false }) as string;
};

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  const values = node.data?.values;

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        cardStyles={actionCardStyles}
        node={node}
        label={t('title')}
        descriptionText={getConditionDescription({ values })}
        tooltip={getConditionTooltip({ values })}
        renderBelowDescription={
          <>
            <MoreItems items={values?.conditions} />
            {node.data.isHalted && node.data.isCompleted && (
              <Tag
                size="large"
                styles={tagStyles}
                text={t('conditionNotMet')}
                variant="indigo-trans-bg"
                icon={<IconCloseSmall />}
              />
            )}
          </>
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Condition',
    more: '{0} more ..',
    conditionNotMet: 'Condition not met',
  },
};
